'use strict';

// @todo remove this for the current setup?
// import 'core-js/stable';
// import 'core-js/modules/es.promise';
// import 'core-js/modules/es.array.iterator';
// import 'regenerator-runtime/runtime';

'use strict';

// 1. Force-override the CSS :has support flag BEFORE any imports run
// if (typeof window !== 'undefined') {
//   window.jQuery = window.$ = {
//     support: {cssHas: true},
//   };
// }
const main = async () => {
  import('./import/_leaked.js');
  // import('./import/jquery-version');
  // import('./import/lodash');
  import('./import/bootstrap_.js');
  // import('./import/cookie.js');
  import('./import/intersectionObserver.js');
  import('./import/smoothscroll.js');
  // import('./import/fontloaderDef.js');
  import('./import/bootstrap-tooltip.js');
  if (window.location.pathname === '/' || window.location.pathname === '/index.php') {
    import('./import/bootstrap-carousel.js');
  }
  if (window.location.pathname.includes('portfolio') || window.location.pathname.includes('upproject') || window.location.search.includes('mact=UpProject')) {
    import('./import/lightgallery.js');
  }
  if (window.location.pathname.includes('news') || window.location.search.includes('mact=News')) {}
  if (window.location.pathname.includes('contact')) {
    await import('./import/vue-leaflet.js');
    await import('./import/vue-contactform.js');
  }
};
main();

//
// EOF
//